import styled from "styled-components";
import termsOfService from "../../../../public/GistMD_Terms_of_Use.pdf#navpanes=0";

export default function TermsOfUse({}) {
  return (
    <iframe
      src={termsOfService}
      style={{ width: "100%", height: "100vh", border: "none" }}
    />
  );
}

const Container = styled.div`
  color: #1A1A1A;
  font-family: Abraham;
`

const Terms = styled.div`
  margin-left: 26px;
  margin-right: 26px;
`

const Title = styled.p`
  margin: 0;
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 23px;
  margin-top: 35px;
`

const BulletText = styled.p`
  margin: 0;
  font-size: 19px;
  font-weight: 500;
  margin-bottom: 26px;
`

const Text = styled.p`
  margin: 0;
  font-size: 19px;
  margin-bottom: 26px;
`

const Span = styled.span`
  margin: 0;
  font-size: 19px;
  font-weight: 400;
`